<!-- 预览详情-->
<template>
    <div class="content-panel">
        <el-row :gutter="10" type="flex" justify="space-between" align="middle" class="breadcrumb-wrap">
            <el-col :span="20">
                <el-breadcrumb separator="/">
                    <el-breadcrumb-item :to="{ path: '/' }">{{msg('首页')}}</el-breadcrumb-item>
                    <el-breadcrumb-item :to="{ path: '/admin/stock'}">{{msg('货运管理')}}</el-breadcrumb-item>
                    <el-breadcrumb-item>{{msg('预览详情')}}</el-breadcrumb-item>
                </el-breadcrumb>
            </el-col>
          </el-row>
        <div class="table-wrap">
            <vxe-grid class="data-table" ref="dataTable" :height="docHeight"
                resizable border
                align="center"
                :data="datas"
                :loading="loading"
                :mergeCells="mergeCells"
                @scroll="scrollCallback"
            >
                <vxe-column field="code" min-width="100">
                    <template #header>
                      {{msg('基本资料')}}
                    </template>
                    <template #default="{ row }">
                        <div style="line-height: 120%">
                            <div style="font-size: 12px;" className="code">{{row.id}}</div>
                            <div style="font-size: 12px;" className="code">{{row.code}}</div>
                            <div style="font-size: 12px;" className="shopName">{{row.shopName}}</div>
                            <div style="font-size: 12px;" className="expCompany">{{row.expCompany}}</div>
                            <div style="font-size: 12px;" className="created">{{row.created}}</div>
                            <div style="font-size: 12px;" className="payTime">{{row.shopDayToShip}}</div>
                            <!-- <div style="font-size: 12px;" className="shopName">{{row.productName}}</div> -->
                            <div style="font-size: 12px;" className="payTime">
                                <span style="font-size: 12px;">{{row.productName}}</span>
                                <el-link :underline="false" type="primary" @click="updateProductName(row)" title="更新品名">
                                    <i class="el-icon-edit-outline"></i>
                                </el-link>
                            </div>
                        </div>
                    </template>
                </vxe-column>
                <vxe-column field="productThumb" min-width="90">
                    <template #header>
                        {{msg('商品图')}}
                    </template>
                    <template #default="{ row, rowIndex }">
                        <template v-if="row.code">
                            <ConcurrencyImage 
                                :key="String(row.id || rowIndex) + '-' + String(row.detail && row.detail.productThumb ? row.detail.productThumb : '')"
                                style="width: 80px; height: 80px" :src="imgUrl+row.detail.productThumb"
                                :preview-src-list="[imgUrl+row.detail.productThumb]"
                                fit="contain">
                            </ConcurrencyImage>
                            <el-upload
                                class="xm-upload"
                                :action="upload"
                                :show-file-list="false"
                                :with-credentials="true"
                                :on-success="(res) => handUploadSuccess(res, rowIndex, row.detailIndex)"
                            >
                                <el-link type="success" icon="el-icon-picture" style="font-size:12px;">上传图片</el-link>
                            </el-upload>
                        </template>
                    </template>
                </vxe-column>
                <vxe-column field="productTitle" min-width="100">
                    <template #header>
                        {{msg('商品标题')}}
                    </template>
                    <template #default="{ row }"> 
                        <template v-if="row.code">
                            <el-tooltip class="item" effect="dark" :content="row.detail.productTitle" placement="top-start">
                                <div class="multi-line-ellipsis" style="padding: 6px 0px; ">
                                    <el-link target="_blank" style="font-size:12px;" 
                                        @click="{viewLink(row.detail)}" 
                                    >
                                        <span class="auto-break"> {{row.detail.productTitle}}</span>    
                                    </el-link>
                                </div>
                            </el-tooltip>
                            <div className="payTime">
                                <span style="font-size: 12px;">{{row.detail.detailProductName}}</span>
                            </div>
                        </template>
                    </template>
                </vxe-column>
                <vxe-column min-width="120">
                    <template #header>
                      {{msg('规格/SKU/货号')}}
                    </template>
                    <template #default="{ row, rowIndex }">
                        <div style="line-height:120%" v-if="row.code">
                            <div  style="font-size: 12px;">{{row.detail.productSpec}}</div>
                            <div>
                                <span style="font-size: 12px; color:#5daf34;">{{row.detail.sku}}</span>
                                <el-link :underline="false" type="primary" @click="updateVariationSku(rowIndex, row.detailIndex,0)" title="更新SKU">
                                    <i class="el-icon-edit-outline"></i>
                                </el-link>
                            </div>
                            <div>
                                <span style="font-size: 12px; color:#409eff;">{{row.detail.variationSku}}</span>
                                <el-link :underline="false" type="danger" @click="updateVariationSku(rowIndex, row.detailIndex,1)" title="更新货号">
                                    <i class="el-icon-edit"></i>
                                </el-link>
                            </div>
                        </div>
                    </template>
                </vxe-column>
                <vxe-column min-width="70">
                    <template #header>
                        {{msg('数量/价格/成本')}}
                    </template>
                    <template #default="{ row, rowIndex }">
                        <div v-if="row.code" style="line-height: 120%;">
                            <div class="spec">
                                <span>{{row.detail.productQty}}</span>件
                                <el-tooltip class="item" effect="dark" content="更新数量" placement="top-start">
                                    <el-link :underline="false" type="danger" @click="updateQty(rowIndex, row.detailIndex,1)" title="更新数量">
                                        <i class="el-icon-edit"></i>
                                    </el-link>
                                </el-tooltip>
                            </div>
                            <div>{{row.detail.productPrice || 0}}</div>
                            <div style="color:#409eff;">
                                {{row.detail.cost}}
                                <el-link :underline="false" type="danger" @click="doUpdateCost(rowIndex, row.detailIndex,1)" title="更新成本">
                                    <i class="el-icon-edit"></i>
                                </el-link>
                            </div>
                        </div>
                    </template>
                </vxe-column>
                <vxe-column min-width="70">
                    <template #header>
                        {{msg('点到/操作')}}
                    </template>
                    <template #default="{ row, rowIndex }">
                        <div v-if="row.code" style="line-height: 220%;">
                            <div>
                                <el-checkbox v-model="row.detail.mark"
                                    @change="(val) => updateMark(rowIndex, row.detailIndex, val)"
                                    :true-label="1"
                                    :false-label="0">
                                </el-checkbox>
                                {{msg('点到')}}
                            </div>
                            <div>
                                <el-button type="success" size="mini" title="新增" @click="addDetail(row)" icon="el-icon-circle-plus-outline">新增</el-button>
                            </div>
                            <div>
                                <el-button type="danger" size="mini" title="删除" @click="deleteDetail(row,row.detail)" icon="el-icon-delete">删除</el-button>
                            </div>
                        </div>
                    </template>
                </vxe-column>
                <vxe-column min-width="160">
                    <template #header>
                        {{msg('快递单号/架位号')}}
                    </template>
                    <template #default="{ row, rowIndex }">
                        <div v-if="row.code" style="line-height:120%;">
                            <el-select v-model="row.detail.storeId"  placeholder="选择到货仓库" size="mini"
                                @change="(val)=>selectedStore(rowIndex, row.detailIndex,0,val)"
                            >
                                <el-option
                                    v-for="item in stores"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                                </el-option>
                            </el-select>
                            <div>{{row.detail.upperDate}}</div>
                            <span v-if="row.detail.innerExpCode">
                                <a target="_blank" :href="'https://www.baidu.com/s?wd='+row.detail.innerExpCode"><i class="el-icon-link"></i></a>
                                {{row.detail.innerExpCode}}
                            </span>
                            <el-link :underline="false" type="primary" @click="updateCode(rowIndex, row.detailIndex,0)" title="更新快递单号">
                                <i class="el-icon-edit-outline"></i>
                            </el-link>
                            <div style="margin-top:5px;">{{row.detail.shelfCode}}</div>
                            <el-link :underline="false" type="danger" @click="deleteInnerCode(rowIndex, row.detailIndex)">
                                <i class="el-icon-delete"></i>
                            </el-link>

                        </div>
                    </template>
                </vxe-column>
                <vxe-column min-width="160">
                    <template #header>
                        {{msg('采批')}}
                    </template>
                    <template #default="{ row, rowIndex }">
                        <div v-if="row.code" style="line-height:120%; padding: 4px 0;">
                            <div v-if="row.detail.purchaseStatus==1" style="color: #67C23A; font-size:12px; ">已采购</div>
                            <div v-else style="color: #f56c6c; font-size:12px; ">未采购</div>
                            <div style="margin-top:5px" v-if="row.detail.purchaseStatus==1">
                                <span>{{row.detail.purchaseTime}}</span>
                            </div>
                            <div style="margin-top:5px">
                                <el-input size="mini" placeholder="采购单号" v-model="row.detail.purchaseCode" @change="changePurchaseCode(row.detail)">
                                </el-input>
                            </div>
                            <div style="margin-top:5px">
                                <el-select v-model="row.detail.purchasePlatform" placeholder="平台" size="mini">
                                    <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
                                </el-select>
                            </div>
                            <div style="margin-top:5px">
                                <el-button v-if="row.detail.purchaseStatus!=1" type="primary" size="mini" 
                                    @click="openBuyLink(rowIndex, row.detail)"
                                >
                                    {{msg('采购')}}
                                </el-button>
                                <el-button size="mini" type="success" @click="savePurchaseCode(rowIndex, row.detailIndex)">{{msg('保存')}}</el-button>
                                <el-button v-if="row.detail.purchaseStatus!=1" size="mini" type="info" @click="selectPurchaseCode(rowIndex, row.detailIndex)">{{msg('选择')}}</el-button>
                                <el-button v-if="row.detail.purchaseStatus==1" size="mini" type="danger" 
                                    @click="rebackPurchaseCode(rowIndex, row.detailIndex)"
                                >{{msg('撤销')}}
                                </el-button>
                            </div>
                        </div>
                    </template>
                </vxe-column>
                <vxe-column field="code" min-width="120">
                    <template #header>
                        {{msg('总额/状态/货态/预估进账')}}
                    </template>
                    <template #default="{ row, rowIndex }">
                        <template v-if="row.code">
                            <div class="amtOrder">{{row.amtOrder || 0}} <el-tag type="danger">{{row.track || msg('准备出货')}}</el-tag></div>
                            <div style="margin-top:5px;">
                                <el-button size="mini" @click="openExps(rowIndex)" plain style="cursor: pointer;" type='primary'>{{dicts.stockStatus.find(e => e.value === row.status)?.label || row.status}}</el-button>
                            </div>
                            <div>
                                {{dicts.stockExpPkgType.find(e => e.value === row.expPkgType)?.label || row.expPkgType}}
                            </div>
                            <el-tag v-if="row.storeName" style="margin: 5px 0px;" type="primary">
                                {{row.storeName}}
                            </el-tag>
                            <el-tag v-if="row.transport" style="margin: 5px 0px;" type="success">
                                {{row.transport}}
                            </el-tag>
                            <!-- <el-tag v-if="row.escrowAmount" style="margin: 5px 0px;" type="success">
                                预估进账：
                                {{row.escrowAmount}}
                            </el-tag> -->
                            <div>
                                预估进账:
                                {{row.escrowAmount}}
                            </div>
                        </template>
                    </template>
                </vxe-column>
                <vxe-column field="code" min-width="80">
                    <template #header>
                        {{msg('买家备注/卖家备注')}}
                    </template>
                    <template #default="{ row,rowIndex }">
                        <div v-if="row.code" style="line-height:120%">
                            <div style="font-size:12px; color:#5daf34;">{{row.shopSellerMsg}}</div>
                            <div  style="font-size:12px;">{{row.note}}</div>
                            <div  style="font-size:12px;color:#409eff;">商家平台</div>
                            <div>
                                <span style="font-size:13px;">{{row.storePlatform}}</span>
                                <el-link :underline="false" type="primary" @click="updateStorePlatform(rowIndex,1)" title="更新商家平台">
                                    <i class="el-icon-edit"></i>
                                </el-link>
                            </div>
                            <div  style="font-size:12px;color:#409eff;">货物类型</div>
                            <div>
                                <span style="font-size:13px;">{{dicts.stockExpGoodType.find(e => e.value === row.expGoodType)?.label || ''}}</span>
                                <el-link :underline="false" type="primary" @click="updateExpGoodType(rowIndex)" title="更新货物类型">
                                    <i class="el-icon-edit"></i>
                                </el-link>
                            </div>
                        </div>
                    </template>
                </vxe-column>
                <vxe-column field="code" min-width="80">
                    <template #header>
                        {{msg('报单备注/货单备注')}}
                    </template>
                    <template #default="{ row, rowIndex }">
                        <div v-if="row.code" style="line-height:120%">
                            <div >
                                <span style="font-size:12px;color:#5daf34;">{{row.remark1}}</span>
                                <el-link :underline="false" type="primary" @click="updateRemark(rowIndex,1)" title="更新报单备注">
                                    <i class="el-icon-edit-outline"></i>
                                </el-link>
                            </div>
                            <div>
                                <span style="font-size:12px;">{{row.remark2}}</span>
                                <el-link :underline="false" type="danger" @click="updateRemark(rowIndex, 2)" title="更新货单备注">
                                    <i class="el-icon-edit"></i>
                                </el-link>
                            </div>
                        </div>
                    </template>
                </vxe-column>
            </vxe-grid>
        </div>

        <stock-detail-purchase ref="purchasDg" :stocks="selectedStocks" @finish="getData"/>
        <add-stock-detail-dialog ref="AddStockDetailDialogRef" @finish="getData"/>

        <sku-update-dialog ref="SkuUpdateDialogRef" @finish="getData"/>
        <!--更新成本-->
        <cost-update-dialog ref="CostUpdateDialogRef" @finish="getData"/>
        <!--选择采购单号-->
        <search-purchase-code-dialog ref="SearchPurchaseCodeDialogRef" @finish="finishSearchPurchaseCode"/>
        <buy-dialog ref="BuyDialogRef" @finish="getData"/>
        <trace ref="traceRef"></trace>

        <el-dialog :title="msg('更新货物类型')" :visible.sync="expGoodTypeVisible" :close-on-click-modal="false" width="420px">
            <el-select v-model="expGoodTypeValue" :placeholder="msg('请选择')" clearable style="width: 100%;">
                <el-option v-for="item in dicts.stockExpGoodType" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
            <span slot="footer" class="dialog-footer">
                <el-button @click="expGoodTypeVisible = false">{{msg('取消')}}</el-button>
                <el-button type="primary" :loading="expGoodTypeSaving" @click="submitUpdateExpGoodType()">{{msg('确定')}}</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import StockDetailPurchase from "./StockDetailPurchase.vue";
import StockDetailService from './StockDetailService.js';
import OrderService from '../order/OrderService.js';
import AddStockDetailDialog from "../order/AddStockDetailDialog.vue"
import SkuUpdateDialog from "../order/SkuUpdateDialog.vue"
import CostUpdateDialog from "../order/CostUpdateDialog.vue"
import SearchPurchaseCodeDialog from "../order/SearchPurchaseCodeDialog.vue"
import BuyDialog from "../order/BuyDialog.vue"
import Trace from "./StockTrace.vue";

export default {
    name: "StockDetail",
    components: {
        StockDetailPurchase:StockDetailPurchase,
        AddStockDetailDialog:AddStockDetailDialog,
        SkuUpdateDialog:SkuUpdateDialog,
        CostUpdateDialog:CostUpdateDialog,
        BuyDialog:BuyDialog,
        Trace:Trace,
        SearchPurchaseCodeDialog:SearchPurchaseCodeDialog,
    },
    mounted(){
        this.user  = JSON.parse(localStorage.getItem("user"));
        this.init();
    },
    data(){
        return {
            loading: false,
            datas: [],
            mergeFields: ['code'],
            imgUrl: this.$kit.api.imgView,
            detailId: this.$kit.api.shopeeDetail1,
            ids: null,
            user:null,
            currIdx: null, //当前操作的单号
            detailIdx: null,
            stockId:null,
            checkId:null,//查看货运的详情ID
            upload: this.$kit.api.upload+"?type=product&auth=1",
            stores:[],
            pruchaseId:null,
            pruchaseId1:null,
            options:[
                {label:'淘宝',value:'taobao'},
                {label:'1688',value:'alibaba'},
                {label:'拼多多',value:'pdd'},
            ],
            mergeCells: [],
            selectedStocks: null,
            hist:0,
            expGoodTypeVisible: false,
            expGoodTypeSaving: false,
            expGoodTypeRowIndex: null,
            expGoodTypeValue: null,

        }
    },
    computed: {
        isMinScreen: { //是否小屏幕，浏览器
            get() {
                return this.$store.state.isMinScreen;
            }
        },
        docHeight: { //表格的高度
            get() {
                var height = this.$store.state.docHeight;
                return height - 165;
            }
        },
        orderInfoWindowId: { //订单详情窗口id
            get() {
                var is = this.$store.state.orderInfoWindowId;
                return is;
            }
        }, 
    },
    methods:{
        init(){
            this.ids = window.localStorage.getItem("viewDetailIds");
            this.hist = window.localStorage.getItem("detailHistory");
            this.getStores();
            this.getData();
        },
        mergeRow() {
            this.mergeCells = [];
            this.mergeCells = StockDetailService.mergeRow(
                this.$refs.dataTable, 
                this.mergeFields
            );
        },
        scrollCallback(scroll, event) {
            if (scroll.type != 'body' || !scroll.isY) {
                return;
            }
            this.mergeRow();
        },
        changeShelfCode(idx, idx1){
            // this.currIdx = idx;
            // this.detailIdx = idx1;

            // let data = this.datas[idx];
            // let detail = data.details[idx1];

            // let msg = "";
            // let type = -1;
            // if(detail.checked){
            //     msg = this.msg('确定需要点到吗');
            //     type = 2;
            // }else{
            //     type = 1;
            //     msg = this.msg('确定需要取消点到吗');
            // }

            // this.$prompt(msg, this.msg('提示'), {
            //     confirmButtonText: this.msg('确定'),
            //     cancelButtonText: this.msg('取消'),
            // }).then(({ value }) => {
            //     this.updateCode(data.id, detail.id, type);
            // }).catch(() => {
            //     this.$message({
            //         type: 'info',
            //         message: '取消输入'
            //     });
            //     data.checked = true;
            // });

        },
        getData(){
            var idArr = this.ids.split(",");
            let query =  {ids:idArr.map(d => d*1)};
            
            const buildEmptyRow = (row) => {
                let emptyRow = {};

                Object.keys(row).forEach(key => {
                    if(key == 'detail'){
                        let d = {};
                        emptyRow[key] = d;
                        let detail = emptyRow[key];
                        Object.keys(detail).forEach(subKey => {
                            d[subKey] = null;
                        });
                    }else if(key == 'code'){
                        emptyRow[key] = '';
                    }else{
                        emptyRow[key] = null
                    }
                });
                return emptyRow;
            }

            let _this = this;
            StockDetailService.getData(
                query, 
                (resultData, total) => { 
                    let newData = [];
                    let code = null;
                    let emptyRow = null;

                    for(let i = 0; i<resultData.length; i++){
                        let row = resultData[i];
                        // if(code && row.code != code){

                        //     if(!emptyRow){
                        //         emptyRow = buildEmptyRow(row);
                        //     }
                        //     newData.push(emptyRow);
                        // }
                        newData.push(row);
                        code = row.code;
                    }
                    _this.datas = newData;
                    _this.$nextTick(() => {
                        _this.mergeRow();
                    });
                },
                isLoad => {
                    _this.loading = isLoad;
                },
                this.hist
            );
        },
        getStores(){
            StockDetailService.getStores((resultData) => {
                this.stores = resultData;
            });
        },
        //更新保单备注，更新货单备注
        updateRemark(rowIndex, type){

            if(this.hist==1){
                this.$message(this.msg('历史数据无法操作'));
                return;
            }

            StockDetailService.updateRemark(
                this.datas[rowIndex],
                type,
                this.getData
            );
        },
        //更新商家平台
        updateStorePlatform(rowIndex, type){
            // type,1-商家平台，2-信用代码
            if(this.hist==1){
                this.$message(this.msg('历史数据无法操作'));
                return;
            }
            StockDetailService.updateStorePlatform(
                this.datas[rowIndex],
                type,
                this.getData
            );
        },
        updateExpGoodType(rowIndex){
            if(this.hist==1){
                this.$message(this.msg('历史数据无法操作'));
                return;
            }
            this.expGoodTypeRowIndex = rowIndex;
            this.expGoodTypeValue = this.datas[rowIndex] ? this.datas[rowIndex].expGoodType : null;
            this.expGoodTypeVisible = true;
        },
        submitUpdateExpGoodType(){
            if(this.expGoodTypeRowIndex === null || this.expGoodTypeRowIndex === undefined){
                this.expGoodTypeVisible = false;
                return;
            }
            let stock = this.datas[this.expGoodTypeRowIndex];
            if(!stock){
                this.expGoodTypeVisible = false;
                return;
            }
            this.expGoodTypeSaving = true;
            this.$axios.post(
                this.$kit.api.stockDetail.updateExpGoodType+'?sid='+stock.id+'&gType='+this.expGoodTypeValue,
            ).then((result) => {
                if(result.status){
                    this.expGoodTypeVisible = false;
                    this.getData();
                    this.$message(result.msg || this.msg('更新成功'));
                }else{
                    this.$message(result.msg || this.msg('更新失败'));
                }
                this.expGoodTypeSaving = false;
            }).catch(() => {
                this.expGoodTypeSaving = false;
                this.$message(this.msg('更新失败'));
            });
        },
        //更新快递单号，更新架位号
        updateCode(rowIndex, detailIndex, type){

            if(this.hist==1){
                this.$message(this.msg('历史数据无法操作'));
                return;
            }

            StockDetailService.updateCode(
                this.datas[rowIndex],
                this.datas[rowIndex].details[detailIndex],
                this.user.username,
                type,
                this.getData               
            );
        },
        viewLink(detail){
            let link = '';
            const shopIdStr = detail.shopId == null ? '' : String(detail.shopId);
            if(shopIdStr.length >= 13){
                link = 'https://www.tw.coupang.com/vp/products/'+detail.productId;
            }else{
                link = 'https://xiapi.xiapibuy.com/product/'+detail.shopId+'/'+detail.productId;
            }

            if(this.hist==1){
                this.$message(this.msg('历史数据无法操作'));
                return;
            }

            this.$confirm(link, '产品链接：', {
                confirmButtonText: '打开',
                cancelButtonText: '复制产品ID',
                type: 'warning'
            }).then(() => {

                window.open(link, "_blank");

            }).catch(() => {
                // window.navigator.clipboard.writeText(link)
                // 创建一个临时的文本区域
                const tempInput = document.createElement('textarea');
                // 设置要复制的文本内容
                let productId  = link.substring(link.lastIndexOf('/')+1);
                tempInput.value = productId;
                tempInput.style="opacity:0;"
                // 追加到 body 中
                document.body.appendChild(tempInput);
                // 选中文本
                tempInput.select();
                // 执行复制操作
                document.execCommand('copy');
                // 移除临时文本区域
                document.body.removeChild(tempInput);
                this.$message("成功");
            });

        },
        openExps(rowIndex){
            let stock = this.datas[rowIndex];
            console.log(this.hist);
            this.$refs.traceRef.showTracks(stock.id, this.hist);
        },
        //更新SKU, 更新货号
        updateVariationSku(rowIndex, detailIndex, type){

            if(this.hist==1){
                this.$message(this.msg('历史数据无法操作'));
                return;
            }

            // StockDetailService.updateVariationSku(
            //     this.datas[rowIndex],
            //     this.datas[rowIndex].details[detailIndex],
            //     type,
            //     this.getData
            // );
            let stock = this.datas[rowIndex];
            let detail = stock.details[detailIndex];
            let sku = {
                stockId:  stock.id,
                detailId:detail.id,
                sku: detail.sku,
                variationSku: detail.variationSku, 
            }

            this.$refs.SkuUpdateDialogRef.showDialog(sku, stock.id, detail.id, 0);
        },
        //更新成本
        doUpdateCost(rowIndex, detailIndex, type){

            if(this.hist==1){
                this.$message(this.msg('历史数据无法操作'));
                return;
            }

            let stock = this.datas[rowIndex];
            let stockDetail = stock.details[detailIndex];
 
            this.$refs.CostUpdateDialogRef.showDialog(stockDetail.id);
           
        },
        //选择到货仓库
        selectedStore(rowIndex, detailIndex, type, storeId){
            if(this.hist==1){
                this.$message(this.msg('历史数据无法操作'));
                return;
            }

            StockDetailService.selectedStore(
                this.datas[rowIndex].details[detailIndex].id,
                storeId, 
                type,
                this.getData 
            );
        },
        //删除快递单号
        deleteInnerCode(rowIndex,detailIndex){
            if(this.hist==1){
                this.$message(this.msg('历史数据无法操作'));
                return;
            }

            StockDetailService.deleteInnerCode(
                this.datas[rowIndex].details[detailIndex].id,
                this.getData
            );
        },
        //点到
        updateMark(rowIndex, detailIndex, markVal){
            if(this.hist==1){
                this.$message(this.msg('历史数据无法操作'));
                return;
            }

            let stock = this.datas[rowIndex];
            let stockDetail = stock.details[detailIndex];
            StockDetailService.updateMark(
                stock.id,
                stockDetail.id,
                markVal,
                this.getData
            );
        },
        //新增一条详情
        addDetail(stock){
            if(this.hist==1){
                this.$message(this.msg('历史数据无法操作'));
                return;
            }

            this.$refs.AddStockDetailDialogRef.showDialog({
                stockId: stock.id,
                status: stock.status
            });

        },
        openStoreDg(){
            this.$nextTick(() => {
                this.$refs.storeDg.init();
            });
        },
        deleteDetail(stock,stockDetail){//删除详情
            if(this.hist==1){
                this.$message(this.msg('历史数据无法操作'));
                return;
            }
            OrderService.deleteDetail({id: stockDetail.id, status: stock.status}, this.getData);
        },
        //打开采购链接
        openBuyLink(rowIndex, detail){
            console.log("exec openBuyLink");
            if(this.hist==1){
                this.$message(this.msg('历史数据无法操作'));
                return;
            }
            //检测是否是最新版本插件
            /* global chrome */
            const extId = document.body.getAttribute('ba-ext-id');
            if(extId && window.chrome && chrome.runtime){
                let responded = false;
                const timeoutId = setTimeout(() => {
                    if(responded){
                        return;
                    }
                    responded = true;
                    this.$message("请先更新插件到最新版本");
                }, 1000);
                chrome.runtime.sendMessage(extId, {
                    action: 'getVersion',
                }, response => {
                    if(responded){
                        return;
                    }
                    responded = true;
                    clearTimeout(timeoutId);
                    if (chrome.runtime.lastError) {
                        this.$message("插件版本过低，请移除后下载安装最新版本");
                        return;
                    }
                    if (response && response.data) {
                        const version = response.data;
                        if(this.$kit.compareVersion(version, this.dicts.chromeVersion) < 0){
                            this.$message("插件版本过低，请移除后下载安装最新版本");
                            return;
                        }else{
                            this.doOpenBuyLink(rowIndex, detail);
                        }
                    }else{
                        this.$message("插件版本过低，请移除后下载安装最新版本");
                        return;
                    }
                });
            }else{
                this.$message("插件版本过低，请移除后下载安装最新版本");
                return;
            }
        },
        doOpenBuyLink(rowIndex, detail){
            let stock = this.datas[rowIndex];
            let selectes = [
                {
                    id:detail.id,
                    stockId:stock.id,
                    sku:detail.sku,
                    variationSku:detail.variationSku,
                    detailId:detail.id,
                    qty:detail.productQty
                }
            ]
            
            var mergeDetail = {...detail, code: stock.code, stockId: stock.id}

            //通过sku、货号去匹配采购链接，如果获取到则直接跳转
            this.selectedStocks = [{stockId: stock.id, detailId: detail.id, qty: detail.productQty}]
            OrderService.concatPurchaseLink(selectes).then((links) => {
                if(links.length == 1){
                    //这里说明是有采购链接的，直接打开采购网站进行采购，等待采购完成，直接更新数据
                    OrderService.chromeBuy(links[0], mergeDetail, null, (result)=>{
                        if(result.status){
                            this.getData();
                        }
                    });
                }else{
                    this.$refs.BuyDialogRef.checkNeedBuy(mergeDetail, selectes,false, ()=>{
                        this.getData();
                    });
                }
            });
        },
        //保存采购单号
        savePurchaseCode(rowIndex){
            if(this.hist==1){
                this.$message(this.msg('历史数据无法操作'));
                return;
            }
            let stock = this.datas[rowIndex];
            let stockDetail = stock.detail;
            // console.log(stockDetail)
            StockDetailService.savePurchaseCode(
                stock.id,
                stockDetail,
                this.getData
            );
        },
        selectPurchaseCode(rowIndex){
            if(this.hist==1){
                this.$message(this.msg('历史数据无法操作'));
                return;
            }
            //调用插件获取采购单号，获取完以后将数据加载到弹出的列表内，在列表内进行选择，选择完以后，将选择的采购单号保存在采购单号字段内
            this.$refs.SearchPurchaseCodeDialogRef.showDialog(rowIndex);
        },
        finishSearchPurchaseCode(order, rowIndex){
            let stock = this.datas[rowIndex];
            let stockDetail = stock.detail;
            stockDetail.purchaseCode = order.orderCode;
            stockDetail.purchasePlatform = 'pdd';
            stockDetail.cost = order.price;
            stockDetail.purchaseTime = order.created;
            this.savePurchaseCode(rowIndex);
            this.getData();
        },
        //撤销已采购单号
        rebackPurchaseCode(rowIndex, detailIndex){
            if(this.hist==1){
                this.$message(this.msg('历史数据无法操作'));
                return;
            }
            let stock = this.datas[rowIndex];
            let stockDetail = stock.details[detailIndex];
            StockDetailService.rebackPurchaseCode(
                stock.id,
                stockDetail.id,
                this.getData
            );
        },
        updateReport(idx, idx1, val){//报单
            // if(!this.hasPermission("stock:detailEdit")){
            //     this.$message(this.msg('无操作权限'));
            //     return;
            // }
            // let data = this.datas[idx];
            // let detail = data.details[idx1];
            // let label = "";
            // let mark = -1;
            // if(val === 1){
            //     mark = 1;
            //     label = this.msg('确定要报单吗')
            // }else{
            //     mark = 0;
            //     label = this.msg('确定要取消报单吗')
            // }

            // this.$confirm(label, this.msg('报单确认'), {
            //     confirmButtonText: this.msg('确定'),
            //     cancelButtonText: this.msg('取消'),
            // }).then(() => {
            //     this.$axios.post(this.$kit.api.stock.updateDetailReport
            //         +"?t="+mark
            //         +"&id="+data.id
            //         +"&detailId="+detail.id
            //     ).then((result) => {
            //         if(result.status){
            //             this.getData();
            //         }
            //         this.$message(result.msg);
            //     });
            // }).catch(() => {
            //     this.getData();
            //     this.$message({
            //         type: 'info',
            //         message: this.msg('取消'),
            //     });
            // });
        },
        updateQty(rowIndex,detailIndex){
            if(this.hist==1){
                this.$message(this.msg('历史数据无法操作'));
                return;
            }
            let stock = this.datas[rowIndex];
            let detail = stock.details[detailIndex];
            if(detail.shelfCode){
                this.$message("请先删除转寄单号回撤库存再更新数量");
                return;
            }

            StockDetailService.updateQty(
                stock.id,
                detail.id,
                this.getData
            );
        },
        updateProductName(row){
            if(this.hist==1){
                this.$message(this.msg('历史数据无法操作'));
                return;
            }

            StockDetailService.updateProductName(
                row.id,
                row.productName,
                this.getData
            );
        },
        //图片上传的回调函数
        //图片上传成功后将id设置到详情中
        handUploadSuccess(result, rowIndex, detailIndex){
            let stock = this.datas[rowIndex];
            let detail = stock.details[detailIndex];
            StockDetailService.uploadProductPhotoCallback(
                result,
                detail.id,
                ()=>{
                    detail.productThumb = result.data;
                    stock.detail.productThumb = result.data;
                    // this.datas[rowIndex].details[detailIndex].productThumb = res.data;
                    // this.datas[rowIndex].detail.productThumb = res.data;
                }    
            );
        },
        changePurchaseCode(detail){
            if(detail.purchaseCode && detail.purchaseCode.indexOf("-")>-1){
                detail.purchasePlatform = "pdd";
            }
        }
    }
}
</script>

<style lang="scss" scoped>

.data-table{
  min-width:1200px;
  width:99%;
  border-collapse: collapse;
  font-size:12px;
  border-top: 1px solid #bec5d6;
  border-left: 1px solid #bec5d6;
}

.data-table th{font-size:14px; text-align:center;  color: #5f6267;}
.data-table th, .data-table td{
  border-bottom: 1px solid #bec5d6;
  border-right: 1px solid #bec5d6;
  padding: 5px;
}

.data-table td{
  font-size:12px; color:#606266; text-align:center;
}

.data-table .shopName{
  color: #409eff;
}

.data-table .payTime,
.data-table .created,
.data-table .amtOrder
.data-table .shipDate{
  color:#909399;
}
.data-table .spec span,
.data-table .track{
  color:#F56C6C;
}

.table-wrap{
  width:100%;
  overflow:auto;
}

@media screen and (min-width: 1200px) {
  body {
    overflow:auto;
  }
}


.th1 {width: 100px;}
.th2 {width: 120px;}
.th3 {width: 120px;}
.th4 {width: 120px; word-break: break-all;}
.th5 {width: 70px;}
.th6 {width: 70px;}
.th7 {width: 60px; word-break: break-all;}
.th8 {width: 160px; word-break: break-all;}
.th9 {width: 160px; word-break: break-all;}
.th10 {width: 80px; word-break: break-all;}
.th11 {width: 80px; word-break: break-all;}
.th12 {width: 80px; word-break: break-all;}

.data-table::v-deep(.vxe-table--render-default .vxe-body--column.col--ellipsis>.vxe-cell,
.vxe-table--render-default .vxe-footer--column.col--ellipsis>.vxe-cell,
.vxe-table--render-default .vxe-header--column.col--ellipsis>.vxe-cell){
  max-height:none;
}
.data-table::v-deep(.vxe-table--render-default .vxe-body--column.col--ellipsis>.vxe-cell){
  white-space: normal;
}

.multi-line-ellipsis {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3; /* 限制在一个块元素显示的文本的行数 */
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: 1.2em; /* 可以设为任意值，根据实际需要调整 */
    max-height: 7em; /* 根据行高计算出的最大高度，用于多行显示 */
}
</style>
